<template>
<!-- :file-status-text="statusText" -->
  <uploader ref="uploader" :options="options" :autoStart="false"  @file-added="onFileAdded" @file-success="onFileSuccess" @file-progress="onFileProgress" @file-error="onFileError" drag
    class="uploader-app" :class="disabled ? 'disabled' : ''">
    <!-- 不支持H5提示 -->
    <uploader-unsupport></uploader-unsupport>

    <!-- 发起申请 上传按钮 -->
    <div v-if="source == 'createApply'">
      <uploader-btn class="button--primary button--mini butn" ref="uploadBtn" :attrs="attrs">点击上传</uploader-btn>
      <span v-show="id=='10'" style="margin-left:30px">请点击此处，下载：<a target="_blank" :href="`${publicPath}qdplmbv1.0.xlsx`" download="渠道批量规范模板.xlsx">
          <el-button class="filter-item" type="text">《渠道批量规范模板》</el-button>
        </a></span>
      <div class="el-upload__tip" style="font-size:10px;margin-top:5px;line-height: 16px;"><span v-if="minNum>0">最少上传{{minNum}}个文件</span>&nbsp;&nbsp;<span v-if="maxNum>0">最多上传{{maxNum}}个文件</span></div>
    </div>

    <!-- 外包批量上传按钮 -->
    <div v-if="source == 'batch'">
      <uploader-btn class="button--primary button--small button_batch" ref="uploadBtn" :attrs="attrs">
        <i class="el-icon-plus" />
        <span class="button_span">选择上传文件</span>
      </uploader-btn>
    </div>

    <!-- 拖拽上传 -->
    <uploader-drop class="uploaderDrop" :attrs="attrs" v-else>
      <svg-icon class="icon" icon-class="drag_gray_icon" v-if="disabled" />
      <svg-icon class="icon" icon-class="drag_download_icon" v-else />

      <div class="text-box">
        <span>将文件拖到此处，或</span>
        <uploader-btn class="butn" ref="uploadBtn" :attrs="attrs" :single='maxNum === 1?true:false'>点击上传</uploader-btn>
        <div class="el-upload__tip" style="font-size:12px;margin-top:15px;line-height: 12px; color:#E22B4B" v-if="source == 'coop'">上传文件需盖章，文件格式支持：PDF/JPG/PNG
          <div style="margin-top:10px">最多上传1个文件</div>
        </div>
        <div class="el-upload__tip" style="font-size:12px;margin-top:24px;line-height: 12px; color:#999999" v-else>最多上传{{maxNum}}个文件,单个文件大小无限制<span v-if="id=='10'">，仅支持xlsx、xls格式</span></div>
        <!-- <span v-if="id=='18'">，仅支持JPG、PNG格式</span> -->
        <!-- <div class="el-upload__tip" style="font-size:12px;line-height: 12px; " :style="source == 'coop'?{'margin-top':'10px','color':'#E22B4B'}:{'margin-top':'24px','color':'#999999'}">最多上传{{maxNum}}个文件,单个文件大小无限制</div> -->

      </div>
    </uploader-drop>

    <!-- 上传列表 -->
    <uploader-list ref="uploadList">
      <ul class="file-list" slot-scope="props">
        <li v-for="file in props.fileList" :key="file.id">
          <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true">
            <template slot-scope="props">
              <div class="uploader-file-progress" :class="props.progressingClass" :style="props.progressStyle"></div>
              <div class="uploader-file-info">
                <div class="uploader-file-name"><i class="uploader-file-icon" :icon="props.fileCategory"></i>{{props.file.name}}</div>
                <div class="uploader-file-size">{{props.formatedSize}}</div>
                <div class="uploader-file-meta"></div>
                <div class="uploader-file-status">
                  <span v-show="props.status !== 'uploading'">
                    <span v-if="props.status == 'success'">
                      <span v-if="props.response && props.response.repeat">重复上传</span>
                      <span v-else>{{statusText[props.status]}}</span>
                    </span>
                    <span v-else>{{statusText[props.status]}}</span>
                  </span>
                  <span v-show="props.status === 'uploading'">
                    <span>{{props.progressStyle.progress}}</span>
                    <em>{{props.formatedAverageSpeed}}</em>
                    <i>{{props.formatedTimeRemaining}}</i>
                  </span>
                </div>
              </div>
            </template>
          </uploader-file>
          <template v-if="file.isSucess">
            <i class="el-icon-circle-check icon check-icon" style="color:#67C23A"></i>
            <i class="el-icon-close icon close-icon" @click="handleDelete(file)"></i>
          </template>
        </li>
      </ul>
    </uploader-list>

  </uploader>
</template>

<script>
import Vue from 'vue'
import uploader from 'vue-simple-uploader'
Vue.use(uploader)
import SparkMD5 from 'spark-md5';
export default {
  props: {
    // 来源
    source: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      default: ''
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },

    // 最少文件数
    minNum: {
      type: Number,
      default: 0
    },

    // 最大文件数
    maxNum: {
      type: Number,
      default: 20
    },
    //请求地址
    isSource: {
      type: String,
      default: ''
    },
    //回显文件时，控制文件数量
    beforeFileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    //团队空间上传时所需文件夹id
    folderPid: {
      type: Array,
      default: () => {
        return [];
      }
    }

  },
  data() {
    return {
      options: {
        target: this.isSource ? this.isSource : this.$store.getters.uploadUrl, // 上传文件地址
        chunkSize: 10 * 1024 * 1024,   //分块大小
        fileParameterName: 'file', //上传文件时文件的参数名，默认file
        maxChunkRetries: 3,  //最大自动失败重试上传次数
        chunkRetryInterval:10,//重试间隔
        simultaneousUploads: 1, // 并发上传数,默认3
        testChunks: true,     //是否开启分片
        query: {
          folderPid: ""
        },
        checkChunkUploadedByResponse: (chunk, message) => {
          // console.log(chunk.offset)
          let objMessage = JSON.parse(message)
          if (objMessage.skipUpload) { // 秒传
            return true
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
        },
        // query:{
        //     fileUuid: Date.now() + '123' + this.$store.getters.userId
        // },
        permanentErrors: [404, 415, 500, 501, 506, 507]
      },
      attrs: this.source == 'batch' ? { accept: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] } : this.source == 'coop' ? { accept: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'] } : {
        // accept: ['image/*', 'video/*', 'document/*']
      },
      statusText: {
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: 'MD5校验',
        waiting: '等待中'
      },
      publicPath: process.env.BASE_URL,
    }
  },

  methods: {
    // 添加文件
    onFileAdded(file) {
      console.log('监听添加文件=====', file)
      this.options.query.folderPid = this.folderPid && this.folderPid.length > 0 ? this.folderPid[this.folderPid.length - 1] : ""
      this.options.query.url = process.env.VUE_APP_TITLE === 'production'?"https://gateway.yingxiong.com/file-api":"https://test-gateway.yingxiong.com/file-api"
      this.$nextTick(() => {
        this.$set(file, 'isSucess', false)
        let fileList = this.$refs['uploadList'].fileList

        if (this.maxNum) {
          if (fileList.length > this.maxNum - this.beforeFileList.length) {
            //解决上传多个文件大于最大上传数后，多次弹出警告提示的问题
            if (fileList.length - 1 === this.maxNum - this.beforeFileList.length) {
              this.$message.warning('最多只能上传' + this.maxNum + '个文件')
              file.cancel();
              // file.ignored = true
              return false;
            } else {
              file.cancel();
              // file.ignored = true
              return false;
            }
          } else {
            if (this.$refs['uploadList'].$children.length > this.maxNum) {
              file.cancel();
              return false;
            }
          }
        }

        if (this.source == "createApply") {
          // if (this.id == "18") {
          //   var acceptList = ['image/jpeg', 'image/jpg', 'image/png']
          //   if (acceptList.indexOf(file.fileType) == -1) {
          //     file.cancel();
          //     this.$message.error('只能上传JPG/PNG格式的文件')
          //     return false;
          //   }
          // }
          if (this.id == "10") {
            var acceptList = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
            if (acceptList.indexOf(file.fileType) == -1) {
              file.cancel();
              this.$message.error('只能上传xlsx、xls格式的文件')
              return false;
            }
          }

        }

        // console.log(JSON.stringify(this.attrs) !== '{}' &&　this.attrs.accept.indexOf(file.fileType) == -1)
        if (JSON.stringify(this.attrs) !== '{}' && this.attrs.accept.indexOf(file.fileType) == -1) {
          // file.cancel(); 此方法清除文件，此后再有点击文件上传此文件都不会跳入onFileAdded()方法，更不会进行验证和报错
          // file.ignored = true
          file.cancel();

          if (this.source == 'batch') {
            this.$message.error('只能上传excel格式的文件')
          } else if (this.source == 'coop') {
            this.$message.error('只能上传PDF/JPG/PNG格式的文件')
          }
          return false;
        }
        this.computeMD5(file) // 断点续传和秒传
      })
    },

    // 文件继续上传
    onFileProgress(rootFile, file, chunk) {
      // console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
    },

    // 上传文件成功
    onFileSuccess(rootFile, file, response, chunk) {
      console.log('监听上传成功：', response)
      let res = JSON.parse(response);

      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      if (res.skipUpload) {
        file.isSucess = true
        rootFile.fileId = res.fileId
        this.$nextTick(() => {
          this.$emit('onSuccess', res.fileId, this.$refs['uploader'].fileList)
        })
      } else {
        if (res.code == 200) {
          file.isSucess = true
          rootFile.fileId = res.data
          this.$nextTick(() => {
            this.$emit('onSuccess', res.data, this.$refs['uploader'].fileList)


          })
          // console.log('111sucess：',this.$refs['uploader'].fileList)
        }
      }
    },

    // 上传文件失败
    onFileError(rootFile, file, response, chunk) {
      this.$message({
        message: response,
        type: 'error'
      })
    },

    // 文件上传成功后删除文件
    handleDelete(file) {
      file.cancel();
      this.$nextTick(() => {
        this.$emit('onRemove', this.$refs['uploader'].fileList)
      })
    },

    // 计算md5，实现断点续传及秒传
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1024;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();

      file.pause();
      loadNext();
      fileReader.onload = (e => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            this.statusText.paused = '校验MD5 ' + ((currentChunk / chunks) * 100).toFixed(0) + '%'
          })
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          // console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
        }
      });
      fileReader.onerror = function () {
        this.$notify({
          title: '错误',
          message: `文件${file.name}读取出错，请检查该文件`,
          type: 'error',
          duration: 2000
        })
        file.cancel();
      };
      function loadNext() {
        let start = currentChunk * chunkSize;
        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    computeMD5Success(md5, file) {
      file.uniqueIdentifier = md5;
      file.resume(); // 继续上传文件
    },
  }
}
</script>

<style lang="scss" scoped>
.uploader-app {
  .uploaderDrop {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: rgba(58, 137, 255, 0.05);
    border: 2px dashed rgba(58, 137, 255, 0.2);
    border-radius: 4px;
    box-sizing: border-box;
    width: 400px;
    height: 184px;
    text-align: center;
    margin-bottom: 10px;
    padding: 32px 20px 24px;
    cursor: pointer;
    overflow: hidden;
    .icon {
      flex-shrink: 0;
      font-size: 56px;
      color: #c0c4cc;
      margin-bottom: 5px;
      line-height: 50px;
    }
    .text-box {
      color: #606266;
      font-size: 14px;
      text-align: center;
      .butn {
        color: #3a89ff;
        border: 0;
        padding: 0;
      }
    }
  }

  // 上传文件列表
  .file-list {
    // margin-top: 20px;
    li {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .uploader-file {
        flex-grow: 1;
      }
      .icon {
        flex-grow: 0;
        cursor: pointer;
      }
      .check-icon {
        display: block;
      }
      .close-icon {
        display: none;
      }
      &:hover {
        .check-icon {
          display: none;
        }
        .close-icon {
          display: block;
        }
      }
    }
  }
  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }

  ::v-deep .uploader-file {
    height: 40px;
    line-height: 40px;
    border-bottom: 0;
  }

  ::v-deep .uploader-file-info {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    > div {
      // width: auto;
      text-indent: 0px;
      margin: 0 3px;
    }
  }

  ::v-deep .uploader-file-progress {
    background: none;
  }

  ::v-deep .uploader-file-actions {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
  }

  // ::v-deep.uploader-file[status=success] .uploader-file-remove{
  //     display: block;
  // }

  ::v-deep .uploader-file-icon {
    margin-top: 8px;
    &:before {
      content: "" !important;
    }
    &[icon="image"] {
      background: url(../../../../../assets/image-icon.png);
    }
    &[icon="video"] {
      background: url(../../../../../assets/video-icon.png);
    }
    &[icon="document"] {
      background: url(../../../../../assets/text-icon.png);
    }
    &[icon="unknown"] {
      background-image: url(../../../../../assets/zip-icon.png);
      background-size: 100% 100%;
    }
  }
  ::v-deep .uploader-file-actions > span {
    margin-right: 6px;
    margin-top: 12px;
  }

  .button--primary {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
  .button--mini {
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
  .butn {
    line-height: 1;
  }
  .button_batch {
    padding: 8px 17px;
    font-size: 14px;
    background: #3a89ff;
    border-radius: 4px;
    .button_span {
      margin-left: 3px;
    }
  }
}

.disabled {
  pointer-events: none;
  .uploaderDrop {
    background-color: #f7f7f7;
    border: 2px dashed#CCCCCC;
    cursor: not-allowed;
    .text-box {
      color: #999999;
      .butn {
        color: #999999;
      }
    }
  }
}
</style>
